<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item
        v-if="!isLockedPrintMultiplesId"
        :label="$t('views.specialMinimum.form.printMultiplesId')"
        prop="printMultiplesId"
      >
        <a-input
          v-model="form.printMultiplesId"
          :placeholder="$t('views.specialMinimum.form.printMultiplesIdPlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.specialMinimum.column.specOptionName')" prop="specOptionId">
        <a-select
          v-model="form.specOptionId"
          allow-clear
          show-search
          :placeholder="$t('views.specialMinimum.form.specOptionSelectPlaceholder')"
          :loading="specOptionLoading"
          option-filter-prop="_label"
          option-label-prop="_label"
          :filter-option="filterSpecOptionOption"
          style="width: 100%"
          :getPopupContainer="trigger => trigger.parentNode"
          @dropdownVisibleChange="onSpecOptionDropdownVisible"
        >
          <a-select-option
            v-for="opt in specOptionOptions"
            :key="opt.id"
            :value="String(opt.id)"
            :_label="opt.name"
          >
            {{ opt.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.specialMinimum.form.price')" prop="price">
        <a-input-number
          v-model="form.price"
          :min="0"
          :step="0.01"
          :precision="2"
          allow-clear
          style="width: 100%"
          :placeholder="$t('views.specialMinimum.form.pricePlaceholder')"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.specialMinimum.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.specialMinimum.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpecialMinimum, addSpecialMinimum, updateSpecialMinimum } from '@/api/user/specialMinimum'
import { listSpecOption } from '@/api/user/specOption'

/** 特殊起订价：规格选项列表固定按该规格筛选（与 listSpecOption 查询参数一致） */
const SPECIAL_MINIMUM_SPEC_OPTION_SPEC_ID = '647454949810278400'

export default {
  name: 'CreateForm',
  props: {
    defaultPrintMultiplesId: {
      type: [Number, String],
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        printMultiplesId: null,
        specOptionId: null,
        price: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
      },
      specOptionOptions: [],
      specOptionLoading: false
    }
  },
  computed: {
    isLockedPrintMultiplesId () {
      const v = this.defaultPrintMultiplesId
      return v !== null && v !== undefined && v !== ''
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.specialMinimum.title.edit') : this.$t('views.specialMinimum.title.add')
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.specOptionOptions = []
      this.formType = 1
      this.form = {
        id: null,
        printMultiplesId: null,
        specOptionId: null,
        price: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    loadSpecOptionOptions () {
      if (this.specOptionLoading) {
        return
      }
      this.specOptionLoading = true
      listSpecOption({ specId: SPECIAL_MINIMUM_SPEC_OPTION_SPEC_ID, parentId: 0 }).then(res => {
        const data = (res && res.data) || []
        this.specOptionOptions = Array.isArray(data) ? data : []
      }).finally(() => {
        this.specOptionLoading = false
      })
    },
    onSpecOptionDropdownVisible (open) {
      if (open && !this.specOptionOptions.length && !this.specOptionLoading) {
        this.loadSpecOptionOptions()
      }
    },
    filterSpecOptionOption (input, option) {
      const text =
        option &&
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      return (text || '').toLowerCase().includes((input || '').toLowerCase())
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      if (this.isLockedPrintMultiplesId) {
        this.$set(this.form, 'printMultiplesId', this.defaultPrintMultiplesId)
      }
      this.open = true
      this.formTitle = this.$t('views.specialMinimum.title.add')
      this.loadSpecOptionOptions()
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSpecialMinimum({ id: id }).then(response => {
        this.form = response.data
        if (this.form.specOptionId != null && this.form.specOptionId !== '') {
          this.form.specOptionId = String(this.form.specOptionId)
        }
        if (this.form.price != null && this.form.price !== '') {
          const n = Number(this.form.price)
          this.form.price = Number.isFinite(n) ? n : null
        }
        this.open = true
        this.formTitle = this.$t('views.specialMinimum.title.edit')
        this.loadSpecOptionOptions()
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpecialMinimum(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.specialMinimum.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.specialMinimum.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpecialMinimum(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.specialMinimum.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.specialMinimum.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
